const FLOWERS = {
  name: '1-800-Flowers.com, Inc.',
  url: 'https://www.1800flowers.com'
};

const SMARTGIFT = {
  name: 'SmartGift for Business',
  url: 'https://www.smartgiftit.com'
};

export { FLOWERS, SMARTGIFT };
